<script setup lang="ts">
import {Button} from "@/Components/Library";
import Matrix from "./Matrix.vue";

const props = defineProps<{
    question: {[key: string]: any; options: string[]};
    disabled?: boolean;
}>();

const model = defineModel<Record<string, string[]> | string[] | string | null>();

const setResponse = (option) => {
    if (props.question.params.allow_multiple) {
        if (Array.isArray(model.value) && model.value?.includes(option)) {
            model.value = model.value.filter((item) => item !== option);
        } else {
            if (!model.value) {
                model.value = [option];
            } else if (Array.isArray(model.value)) {
                model.value.push(option);
            }
        }
    } else {
        model.value = option;
    }
};

const isSelected = (option) => {
    if (Array.isArray(model.value) && props.question.params.allow_multiple) {
        return model.value?.includes(option);
    } else {
        return option === model.value;
    }
};
</script>
<template>
    <div>
        <Matrix v-if="question.params.matrix" :question="question" v-model="model" :disabled="disabled" />
        <template v-else>
            <h3 class="mb-3 mt-1 px-1 text-sm font-bold">
                Select {{ question.params.allow_multiple ? "one or more" : "an" }} option{{
                    question.params.allow_multiple ? "s" : ""
                }}
            </h3>
            <div :class="[{'grid grid-cols-2 gap-2': question.options[0]?.image}]">
                <template v-for="(option, i) in question.options">
                    <!--                {{ option.params.gatekeeper_positive }}-->
                    <template v-if="option.image">
                        <Button
                            class="flex h-full w-full flex-col rounded-md border-2 !p-0 font-bold focus:!ring-0"
                            :class="[isSelected(option.id) ? 'border-askr-green' : 'border-stone-100 bg-white']"
                            @click="setResponse(option.id)"
                        >
                            <img
                                v-if="option.image?.url"
                                class="h-auto w-full rounded-t-md"
                                :src="option.image.url"
                                :alt="option.value"
                            />
                            <p
                                class="mt-auto w-full px-4 py-2 transition"
                                :class="[
                                    isSelected(option.id)
                                        ? 'border-askr-green bg-askr-green text-white'
                                        : 'border-stone-100 bg-white dark:border-stone-700 dark:bg-stone-800 dark:text-white',
                                ]"
                            >
                                {{ option.value }}
                            </p>
                        </Button>
                    </template>
                    <template v-else>
                        <Button
                            class="mb-1 w-full rounded-md border px-4 py-2 font-bold focus:!ring-0"
                            :class="[
                                isSelected(option.id)
                                    ? 'border-stone-700 bg-stone-700 text-white'
                                    : 'border-stone-300 bg-white dark:border-stone-700 dark:bg-stone-950 dark:text-stone-400',
                            ]"
                            @click="setResponse(option.id)"
                        >
                            {{ option.value }}
                        </Button>
                    </template>
                </template>
            </div>
            <!--        {{ question.options }}-->
        </template>
    </div>
</template>
<style scoped></style>
